module.exports = {"653127100":"麦盖提镇","653127200":"巴扎结米乡","653127201":"希依提墩乡","653127202":"央塔克乡","653127203":"吐曼塔勒乡","653127204":"尕孜库勒乡","653127205":"克孜勒阿瓦提乡","653127206":"库木库萨尔乡","653127207":"昂格特勒克乡","653127208":"库尔玛乡","653127400":"胡杨林场","653127401":"园艺场","653127402":"五一林场","653127500":"兵团农三师前进水库管理处","653127505":"兵团四十五团","653127506":"兵团四十六团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653127.json
// module id = 2895
// module chunks = 0